<template>
    <Teleport to="body">
        <div class="messages" :class="{ 'modals-mode': modals.openedModals?.length }">
            <div class="messages-container">
                <div
                    v-for="message in messages.messages"
                    :key="message.id"
                    class="message"
                    :class="[message.type, message.config?.class ? message.config?.class : '', classes[message.type]]"
                    :style="message.config?.style ? message.config.style : {}"
                >
                    <Icon :icon="message.config?.icon ? message.config.icon : icons[message.type]"
                        :sprite="message.config?.sprite ? message.config.sprite : 'actions'"
                    />
                    <span>{{ message.text }}</span>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import stores from '@/stores';
const messages = stores.messages();
const modals = stores.modals();

const classes = {
    info: 'info',
    success: 'success',
    error: 'attention'
};

const icons = {
    info: 'exclamation',
    success: 'exclamation',
    error: 'exclamation'
};
</script>

<style lang="scss" scoped>
.messages {
    width: 100%;
    position: fixed;
    top: calc(
        var(--max-safe-area-inset-top, var(--tg-safe-area-inset-top, 0px)) + 
        var(--max-content-safe-area-inset-top, var(--tg-content-safe-area-inset-top, 0px))
    );
    z-index: 9999;
    pointer-events: none;
    left: 0;
    right: 0;

    .messages-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        padding-top: 8px;

        .message {
            @include message;
            position: relative;
            max-width: 80%;
            width: auto;
            backdrop-filter: blur(6px);
            -webkit-backdrop-filter: blur(6px);
        }
    }

    &.modals-mode {
        .messages-container {
            .message {
                background-color: var(--white-80);
            }
        }
    }
}
</style>
